module.exports = __webpack_public_path__ + "img/20170704_135648_088.f7c09cf8.jpg";